import {
    Stack
} from '@mantine/core'
import { useEffect, ReactNode } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getEntity } from 'app/state/ducks/entities/selectors'
import { loadOneEntity } from 'app/state/ducks/entities/thunks'
import { ContractType } from 'app/models/common-types'
import { loadNotesByContract } from 'app/state/ducks/notes/thunks'
import ManageEntityWireInstructions from './manage-entity-wireinstruction'
import { getEntityProfiles } from 'app/state/ducks/entity-profile/selectors'
import { getEntityTypes } from 'app/state/ducks/entity-type/selectors'
import { buildEntityDetailSectionForEntityTabs } from 'app/views/components/functions/buildDetailsObjects'
import { DetailSectionHeader } from 'app/views/components/detailSections/detail-section-header'
import { DetailSection } from 'app/views/components/detailSections/detail-section'
import { DataBoxLayout } from 'app/views/components/detailSections/data-box-layout'

export default function WireInstructionsPage() {
    const { entityId, status } = useParams()
    const entity = useSelector(getEntity)
    const entityProfiles = useSelector(getEntityProfiles)
    const entityTypes = useSelector(getEntityTypes)

    const dispatch = useDispatch()

    useEffect(() => {
        if (entityId) {
            dispatch(loadOneEntity(entityId, status ?? 'Inactive'))
            dispatch(loadNotesByContract(entityId, ContractType.Entities))
        }
    }, [entityId])

    const { entityDetails, addressDetails } = buildEntityDetailSectionForEntityTabs(entity, entityProfiles, entityTypes)

    const renderDetailSection = (headerText: string, detailObjArr: any) => (
        <>
            <DetailSectionHeader headerText={headerText} />
            <DetailSection detailObjArr={detailObjArr} columnCount={3} />
        </>
    )

    const renderTableSection = (headerText: string, tableSection: ReactNode) => (
        <>
            <DetailSectionHeader headerText={headerText} />
            {tableSection}
        </>
    )

    return (
        <Stack w="100%" h="130vh">
            <DataBoxLayout
                tableSections={[renderTableSection('Wire Instructions List', <ManageEntityWireInstructions entityId={entity?.id} />)]}
                sections={[
                    [
                        renderDetailSection('Details', entityDetails),
                        renderDetailSection('Address', addressDetails)
                    ]
                ]}
                tablePosition='top'
            />
        </Stack>
    )
}